module.exports = __webpack_public_path__ + "static/dark-shadow-515ad21548e4b78b56f617ba0e217197.svg";